import i18next from 'i18next'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'
import vi from '../../i18n/vi.json'

/**
 * Vietnamese only (ADR 003). Still an i18n catalog rather than inline strings:
 * one file to review every word against the copy rules, ICU plurals, and the
 * integrity test that keeps code and catalog in step.
 */
export type AppLocale = 'vi'

export function initI18n(locale: AppLocale = 'vi'): Promise<unknown> {
  return i18next
    .use(ICU)
    .use(initReactI18next)
    .init({
      lng: locale,
      fallbackLng: 'vi',
      resources: { vi: { translation: vi } },
      interpolation: { escapeValue: false },
      returnEmptyString: false,
    })
}

export default i18next
